import { set } from "lodash";
/* Basically object access, but allows (propagates) null for both the object and key */
export const getProp = (obj, prop) => {
    if (obj == null || prop == null)
        return null;
    return obj[prop];
};
export const setProp = (obj, prop, val) => {
    if (obj == null)
        return;
    obj[prop] = val;
};
/** Because input can be some subtype of TIn, Object.keys will by default
 * not return (keyof TIn)[] but in many cases we know that input doesn't
 * have any properties other than what TIn provides so we can make that assumption */
export const strictKeysOf = (input) => Object.keys(input);
/** Return a new project without propKey */
export const removeProp = (propKey, { [propKey]: propValue, ...rest }) => rest;
export const mapEntries = (input, map) => Object.fromEntries(Object.entries(input).map(([k, v]) => [k, map(v, k)]));
export const countNEVals = (obj, excludeKeys) => {
    let count = 0;
    for (const key of Object.keys(obj)) {
        const val = obj[key];
        if (val == null)
            continue;
        if (excludeKeys?.includes(key))
            continue;
        count += 1;
    }
    return count;
};
export const removeNullishVals = (obj) => Object.fromEntries(Object.entries(obj).filter(([_k, v]) => v != null));
export const dict = (input) => input;
export const redactVals = (obj, keys) => {
    const redacted = { ...obj };
    for (const k of keys) {
        if (redacted[k])
            set(redacted, k, "<redacted>");
    }
    return redacted;
};
export const substituteNullish = (obj, defaults) => {
    const next = { ...obj };
    for (const [key, val] of Object.entries(defaults)) {
        const k = key;
        // biome-ignore lint/suspicious/noExplicitAny: Needed for handling of adhoc data
        if (next[k] == null)
            next[k] = val;
    }
    return next;
};
export const stripNullishVals = (obj) => {
    const next = {};
    for (const key in obj) {
        if (!Object.hasOwn(obj, key))
            continue;
        const val = obj[key];
        if (val != null)
            next[key] = val;
    }
    return next;
};
/** Check if value is a plain object (not null, not array, not Date, not etc.) */
export const isPlainObject = (value) => {
    if (typeof value !== "object" || value === null)
        return false;
    const proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
};
/* export const nestProps = <
TObj extends object,
TNestKey extends string,
TNestProps extends Partial<{ [K in keyof TObj]: true }>
>(
    obj: TObj,
    nestKey: TNestKey,
    propsToNest: TNestProps
): Omit<TObj, keyof TNestProps> & { [k in TNestKey]: Pick<Obj, keyof TNestProps> } => {
    const allEntries = Object.entries(obj);
    const nestEntries: [string, unknown][] = [];
    const restEntries: [string, unknown][] = [];
    for (const entry of allEntries) {
        if (propsToNest[entry[0]]) {
            nestEntries.push(entry);
        } else {
            restEntries.push(entry)
        }
    }
    restEntries.push([nestKey, Object.fromEntries(nestEntries)]);
    return Object.entries(restEntries);
} */
export const mergeAsync = async (...values) => {
    if (!values.length)
        throw new Error("Atleast one object is required");
    const res = {};
    for (const valP of values) {
        Object.assign(res, await valP);
    }
    return res;
};
//# sourceMappingURL=object.js.map